export const comments_3278344 = {"data":{"data":[],"links":{}}}